import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { AddressSchema } from "../generated/prisma/zod";

const c = initContract();

export const addressesContract = c.router({
  findOne: {
    method: "GET",
    path: "/addresses/:id",
    responses: {
      200: AddressSchema,
    },
    summary: "Find an address by ID",
  },
  create: {
    method: "POST",
    path: "/addresses",
    responses: {
      201: AddressSchema,
    },
    body: z.object({
      clientId: z.string().optional(),
      street: z.string(),
      zipCode: z.string(),
      city: z.string(),
      country: z.string().optional(),
    }),
    summary: "Create an address",
  },
  update: {
    method: "PATCH",
    path: "/addresses/:id",
    responses: {
      200: AddressSchema,
    },
    body: z.object({
      clientId: z.string().optional(),
      street: z.string().optional(),
      zipCode: z.string().optional(),
      city: z.string().optional(),
      country: z.string().optional(),
    }),
    summary: "Update an address",
  },
});
